import axios from 'axios';
import config from '@/config';
import * as jwt from 'jsonwebtoken';

export async function fetchUserInfo(accessToken) {
  try {
    const { data } = await axios.get('auth/me', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return data;
  } catch (e) {
    // eslint-disable-next-line no-throw-literal
    throw { ...((e.response && e.response.data) || {}), status: e.response && e.response.status };
  }
}

export async function presignURL({ id, resource }) {
  const { apiBaseUrl } = config;
  const uri = `${resource}/${id}/presigned-urls`;

  const { data: url } = await axios.post(uri);
  return (url.startsWith('http') && url) || `${apiBaseUrl}${url}`;
}

export function parseToken(token) {
  try {
    return jwt.decode(token);
  } catch (err) {
    return undefined;
  }
}
